export default __webpack_public_path__ + "static/media/element_16.180255de.webp";